<template>
  <div>
    <Heading v-if="title" :level="2">{{ title }}</Heading>
    <ul class="download-list">
      <li v-for="item in list" :key="item.url">
        <DownloadButton
          :title="item.title"
          :url="item.url"
          @track-download-button="trackDownloadButton"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Heading } from '@warrenbrasil/nebraska-web';
import { DownloadButton } from '../DownloadButton';

@Component({
  components: {
    Heading,
    DownloadButton
  }
})
export default class DownloadDocument extends Vue {
  @Prop({ type: Array, required: true })
  public list!: string;

  @Prop({ type: String, required: false })
  public title!: string;

  trackDownloadButton(computedTitle: string) {
    this.$emit('track-download-button', computedTitle);
  }
}
</script>

<style lang="less" scoped>
.download-list {
  list-style: none;
  margin: 0 !important;
  padding: 0;

  li + li {
    margin-top: 1em;
  }
}
</style>
